import type { CommentMentionEntity } from "@/modules/social/entities/socialEntity"

export function formatTextWithMentions(
  text: string,
  mentions: CommentMentionEntity[],
  navigateToUserProfile: (userId: string) => void,
): React.ReactNode {
  if (!mentions || mentions.length === 0) return text

  const sorted = [...mentions].sort((a, b) => a.startAt - b.startAt)

  const parts: React.ReactNode[] = []
  let cursor = 0

  for (let i = 0; i < sorted.length; i++) {
    const mention = sorted[i]
    if (!mention) continue
    const { startAt, length } = mention
    const endAt = startAt + length + 1 // +1 accounts for the @ prefix

    if (startAt > cursor) {
      parts.push(text.slice(cursor, startAt))
    }

    parts.push(
      <button
        key={`mention-${i}`}
        onClick={() => {
          navigateToUserProfile(mention.userId)
        }}
        className="text-interactive-text-accent-default cursor-pointer font-semibold"
      >
        {text.slice(startAt, endAt)}
      </button>,
    )

    cursor = endAt
  }

  if (cursor < text.length) {
    parts.push(text.slice(cursor))
  }

  return <>{parts}</>
}
